var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{attrs:{"id":"set-route-id"}},[_c('vue-form-generator',{attrs:{"schema":_vm.schemaAddress,"model":_vm.modelAddress,"options":_vm.formOptionsAddress},on:{"validated":_vm.onFormValidated}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }